import { FileQuestion } from 'lucide-react'

export default function Header() {
    return (
        <div className="relative mb-6 flex size-40 items-center justify-center">
            <div className="bg-surface-dark border-border-dark relative z-10 flex size-20 items-center justify-center rounded-full border text-red-500/80 shadow-[0_0_40px_rgba(255,0,0,0.15)]">
                <FileQuestion size={40} />
            </div>
            <div className="absolute size-[66%] animate-[spin_6s_linear_infinite] rounded-full border-2 border-transparent border-t-red-500/60"></div>
            <div className="absolute size-[83%] animate-[spin_8s_linear_infinite_reverse] rounded-full border-2 border-transparent border-b-red-500/40"></div>
            <div className="absolute size-full animate-[spin_10s_linear_infinite] rounded-full border-2 border-transparent border-l-red-500/20"></div>
        </div>
    )
}
